import React, { useState, useEffect, useCallback } from 'react'
import { useParams, Link } from 'react-router-dom'
import { Card, Alert, Spinner, Badge } from 'react-bootstrap'
import { chatsAPI } from '../../services/chatsApi'
import ChatSectionHeader from './ChatSectionHeader'

const ChatStage = () => {
  const { id, stageId } = useParams()
  const [stage, setStage] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  const loadStage = useCallback(async () => {
    try {
      setLoading(true)
      const response = await chatsAPI.stage(id, stageId)
      setStage(response.data)
      setError(null)
    } catch (err) {
      console.error('Error loading stage:', err)
      setError(err.response?.status === 403 ? 'У вас нет доступа к этому чату' : 'Не удалось загрузить этап')
    } finally {
      setLoading(false)
    }
  }, [id, stageId])

  useEffect(() => {
    loadStage()
  }, [loadStage])

  if (loading) {
    return (
      <div className="text-center py-5">
        <Spinner animation="border" />
      </div>
    )
  }

  if (error) {
    return <Alert variant="danger">{error}</Alert>
  }

  return (
    <div>
      <ChatSectionHeader
        title={`Этап ${stage.number}. ${stage.name}`}
        subtitle={`${stage.chat_name}${stage.tab_type === 'additional' && stage.tab_name ? ` · ${stage.tab_name}` : ''}`}
        backTo={`/chats/${id}`}
      />

      <Card className="shadow-sm border-0">
        <div className="list-group list-group-flush">
          <Link
            to={`/chats/${id}/stages/${stageId}/tasks`}
            className="list-group-item list-group-item-action py-3"
          >
            <div className="d-flex justify-content-between align-items-center gap-2">
              <span className="fw-semibold text-uppercase">Задачи</span>
              <span className="d-flex align-items-center gap-2">
                <Badge bg="light" text="dark" className="border">
                  {stage.tasks.filter((t) => t.completed).length} из {stage.tasks.length}
                </Badge>
                <span className="text-muted">›</span>
              </span>
            </div>
          </Link>
          <Link
            to={`/chats/${id}/stages/${stageId}/acts`}
            className="list-group-item list-group-item-action py-3"
          >
            <div className="d-flex justify-content-between align-items-center gap-2">
              <span className="fw-semibold text-uppercase">Акты</span>
              <span className="d-flex align-items-center gap-2">
                {stage.acts.some((a) => !a.paid) && (
                  <Badge bg="warning" text="dark">
                    не оплачено: {stage.acts.filter((a) => !a.paid).length}
                  </Badge>
                )}
                <Badge bg="light" text="dark" className="border">
                  {stage.acts.length}
                </Badge>
                <span className="text-muted">›</span>
              </span>
            </div>
          </Link>
        </div>
      </Card>
    </div>
  )
}

export default ChatStage
